import React, { useState } from 'react';
import styles from './ParentSetPassword.module.css';

export default function ParentSetPassword({ token }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`/api/parent/accept-invite/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Something went wrong.'); return; }
      localStorage.setItem('ngs_parent_token', data.token);
      setDone(true);
      setTimeout(() => { window.location.href = '/parent'; }, 1500);
    } catch {
      setError('Network error — please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div role="img" aria-label="Next Gen Sports" className={styles.logo} />
        </div>
        <div className={styles.cardBody}>
          {done ? (
            <div className={styles.success}>
              <div className={styles.successIcon}>✓</div>
              <div className={styles.successText}>Account created! Redirecting to your portal...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate>
              <h2 className={styles.title}>Welcome to NGS</h2>
              <p className={styles.subtitle}>Set a password to access your Parent Portal. You'll use your email and this password to sign in.</p>
              {error && <div className={styles.error}>{error}</div>}
              <div className={styles.field}>
                <label className={styles.label}>Password</label>
                <input className={styles.input} type="password" placeholder="Minimum 8 characters"
                  value={password} onChange={e => setPassword(e.target.value)} disabled={loading} />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Confirm Password</label>
                <input className={styles.input} type="password" placeholder="Re-enter password"
                  value={confirm} onChange={e => setConfirm(e.target.value)} disabled={loading} />
              </div>
              <button type="submit" className={styles.submit} disabled={loading || !password || !confirm}>
                {loading ? 'Setting up...' : 'Create Account'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
